module.exports = __webpack_public_path__ + "static/media/__INIT__.d41d8cd9.bin";